
const Home = () => (
  <div>
    <h1>Back Office Home</h1>
    <p>Welcome to the back office dashboard.</p>
  </div>
);

export default Home;
